<template>
  <div>
    <el-dialog
      title="语言"
      :visible="localsMixShow"
      width="800px"
      @close="close"
      @open="openInit"
      append-to-body
    >
      <div class="localsList mix-wrap-locals">
        <p class="batch-p">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <el-select
            v-model="comVal"
            placeholder="请选择语言"
            multiple
            clearable
            filterable
            style="width: 100%"
            v-if="initData.targeting"
            :disabled="!checkedDatas.length"
            @change="(val) => batchChange('locales', val)"
          >
            <el-option
              :label="local.name"
              :value="local.key"
              v-for="local in initData.targeting.TargetingLocale"
              :key="local.key"
            ></el-option>
          </el-select>
        </p>
        <el-checkbox-group
          v-model="checkedDatas"
          @change="
            (val) => handleCheckedDatasChange('locales', localsMsgList, val)
          "
        >
          <el-checkbox v-for="item in dataList" :label="item.id" :key="item.id">
            <el-tooltip v-if="item.name" :content="item.name">
              <span class="mixName">{{ item.name }}</span></el-tooltip
            >
            <el-select
              v-model="item.locales"
              placeholder="请选择语言"
              multiple
              clearable
              filterable
              style="width: 100%"
              v-if="initData.targeting"
            >
              <el-option
                :label="local.name"
                :value="local.key"
                v-for="local in initData.targeting.TargetingLocale"
                :key="local.key"
              ></el-option>
            </el-select>
          </el-checkbox>
        </el-checkbox-group>
        <!-- <el-row :gutter="10" v-for="item in dataList" :key="item.id">
                    <el-col :span="8" style="line-height:40px">
                        <span  class="mixName">{{item.name}}</span>
                    </el-col>
                    <el-col :span="16">
                        <el-select v-model="item.locales" placeholder="请选择语言" multiple clearable filterable style="width:100%" v-if="initData.targeting">
                            <el-option :label="local.name" :value="local.key" v-for="local in initData.targeting.TargetingLocale" :key="local.key"></el-option>
                        </el-select>
                    </el-col>
                </el-row> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mixBatchOperate from "@/views/adManagement/assets/js/mixBatchOperate";
export default {
  mixins: [mixBatchOperate],
  props: ["localsMixShow", "localsMsgList"],
  data() {
    return {
      initData: this.$store.getters.initData,
      dataList: JSON.parse(JSON.stringify(this.localsMsgList)),
    };
  },
  methods: {
    close() {
      this.backToInit(this.localsMsgList);
      this.$emit("update:localsMixShow", false);
    },
    openInit() {},
    sure() {
      this.$emit("setMixMsg", "locales", this.dataList);
      this.close();
    },
  },
  watch: {
    localsMsgList: {
      handler() {
        this.dataList = JSON.parse(JSON.stringify(this.localsMsgList));
      },
    },
  },
};
</script>
<style lang="scss" scope>
.localsList {
  .el-row {
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss">
.mix-wrap-locals {
  .batch-p {
    display: flex;
    align-items: center;
    .el-select {
      margin-left: 10px;
    }
  }
  .el-checkbox-group {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    .el-checkbox {
      width: 95%;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
    }
    .el-checkbox__label {
      width: 100%;
      display: flex;
      align-items: center;
    }
    .el-select {
      width: 300px !important;
    }
    .mixName {
      width: 500px;
    }
  }
}
</style>